import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ml-2" }
const _hoisted_2 = { class: "ml-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", {
    ref: "subNav",
    class: ["absolute right-0 sm:right-auto w-32 sm:w-full overflow-hidden bg-white transition delay-100 duration-300 ease-out transform rounded-lg shadow-lg", {
			'translate-y-16 opacity-0': !_ctx.show,
			'translate-y-2 opacity-100': _ctx.show,
		}]
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (link, i) => {
      return (_openBlock(), _createBlock("div", { key: i }, [
        (link.to)
          ? _createVNode(_component_router_link, {
              key: 0,
              to: link.to,
              class: "px-2 py-3 flex flex-row justify-start items-center text-sm text-gray-600 hover:bg-gray-200"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getIcon(link.icon)), { class: "w-4 h-4" })),
                _createVNode("span", _hoisted_1, _toDisplayString(link.label), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          : (_openBlock(), _createBlock("div", {
              key: 1,
              class: "px-2 py-3 flex flex-row justify-start items-center text-sm text-gray-600 hover:bg-gray-200 cursor-pointer",
              onClick: $event => (_ctx.handleClick(link.value ?? ''))
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getIcon(link.icon)), { class: "w-4 h-4" })),
              _createVNode("span", _hoisted_2, _toDisplayString(link.label), 1)
            ], 8, ["onClick"]))
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2))
}